import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AnimationQueryMetadata } from '@angular/animations';
declare let ga: Function;
import { CommonService } from './shared/services/commom.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';
    IpAddress: any;
    k = 1;



    constructor(private Router: Router, private HttpClient: HttpClient, private CommonService: CommonService,
        private Route: ActivatedRoute) {
        this.HttpClient.get<{ IpAddress: string }>('https://jsonip.com')
            .subscribe(data => {
                this.IpAddress = data
            })
    }

    ngOnInit() {
        debugger
        this.Router.events.subscribe(x => {
            if (x instanceof NavigationEnd) {
                debugger
                // this is using for monitor the user activity
                ga('set', 'page', x.urlAfterRedirects, 'auto', {
                    userId: this.IpAddress.ip
                });
                ga('send', 'pageview');

            }

        })



    }



}